export const BENEFIT_SALARY_FIELD_NAMES = [
  'benefit_salary',
  'benefit_salary2',
  'benefit_salary3',
  'benefit_salary4',
  'benefit_salary5',
  'benefit_salary6',
];

export const MESSAGE_CREATION_DATE_FORMAT = 'yyyy/MM/dd HH:mm:ss ZZZ';
